import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { ChartOptions } from 'chart.js';
import { Color } from 'ng2-charts';

import { propertiesHeader, mockTableProduct } from 'src/app/core/constants/properties-const';
import { FacsService } from 'src/app/facs/service/facs.service';

@Component({
  selector: 'app-properties-table',
  templateUrl: './properties-table.component.html',
  styleUrls: ['./properties-table.component.scss']
})
export class PropertiesTableComponent implements OnInit {


  @Output() public openTable = new EventEmitter<any>();

  private rawListTable;
  @Input() set listTable(listTable) {
    this.rawListTable = listTable;
  }
  get listTable() {
    return this.rawListTable;
  }

  public doughnutChartColorA: Color[] = [{
    borderColor: ['#75e29e', '#ccfaf0'],
    backgroundColor: ['#75e29e', '#ccfaf0']
  }];

  public doughnutChartOptions: ChartOptions = {
    cutoutPercentage: 80,
    legend: { display: false },
    tooltips: { enabled: false },
    elements: {
      arc: {
        borderWidth: 0
      },
    }
  };

  public id = -1;
  public page = 0;
  public index = 1;
  public isListTable = false;
  public isOptions = false;
  public visible = false;
  public isHeaderTable = false;
  public columnId = null;
  public countColumn = 0;

  public listHeaders = propertiesHeader;

  public listOptions = ['Data', 'Data 1'];
  public productsValuesShowing = ['total_area', 'bedrooms', 'bathrooms', 'parkingspots'];

  constructor(
    private service: FacsService,
  ) {}

  ngOnInit() {
    this.service.getOpen().subscribe(x => this.isHeaderTable = x);
  }

  public hoverEvent(event: number) {
    this.id = event;
    this.visible = false;
  }

  public actionTable() {
    this.isListTable = !this.isListTable;
  }

  public getScroll(data) {
    if (data) {
      this.visible = true;
    }
  }

  public actionHeader(event: Event | any, i: number) {
    event.stopPropagation();
    this.requestColumn(i);
  }

  public requestColumn(i: number) {
    if (this.columnId !== i) {
      this.countColumn = 0;
    }
    this.columnId = i;
    this.countColumn += 1;
    if (this.countColumn > 2) {
      this.countColumn = 0;
    }
  }

}
